import React from 'react';
import FooterAction from './footer-action';
import ModalState from '../../state/bank-id/modal-state';
import { useTranslator } from 'static/script/app/lang';

const FooterActions = ({
    onFinish,
    onClose,
    startBankIdAuthentication,
    modalState
}) => {
    const { t } = useTranslator();
    switch (modalState) {
        case ModalState.IN_PROGRESS:
            return (
                <FooterAction
                    text={t('bankIdModal_Cancel')}
                    onClick={onClose}
                />
            );
        case ModalState.COMPLETED:
            return (
                <FooterAction text={t('bankIdModal_Done')} onClick={onFinish} />
            );
        case ModalState.ERROR:
            return (
                <FooterAction text={t('bankIdModal_Close')} onClick={onClose} />
            );
        case ModalState.START:
            return (
                <div className="row my-3">
                    <div className="col-12 d-flex justify-content-center">
                        <button
                            type="button"
                            className="btn btn-secondary mr-4"
                            onClick={onClose}>
                            {t('bankIdModal_Cancel')}
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={startBankIdAuthentication}>
                            {t('bankIdModal_Continue')}
                        </button>
                    </div>
                </div>
            );
    }
    return null;
};

export default FooterActions;
